import React, { createContext, useContext, useMemo, useCallback, useState } from 'react';
import { markerFactory } from 'common/utils/MapMarker';
import { IMap } from 'common/utils/Map/types';

import { MarkersContext as Context } from './types';

interface Props {
  children?: React.ReactNode;
}

export const MarkersContext = createContext({} as Context);
export const useMarkersContext = () => useContext(MarkersContext);

export const MarkersProvider = ({ children }: Props) => {
  const [ markers, setMarkers ] = useState<Context['markers']>(null);

  const initMarkers = useCallback((map: IMap | null) => {
    if (map) {
      const newMarkers = markerFactory(map);
      setMarkers(newMarkers);
    }
  }, [setMarkers]);

  const setOverlayProps: Context['setOverlayProps'] = useCallback((...overlayProps) => {
    if (markers) {
      markers.setOverlayProps(...overlayProps);
    }
  }, [markers]);

  const updateLayers: Context['updateLayers'] = useCallback((newLayers: any) => {
    if (markers) {
      markers.updateLayers(newLayers);
    }
  }, [markers]);

  const value = useMemo(
    () => ({
      markers,
      initMarkers,
      setOverlayProps,
      updateLayers
    }),
    [
      markers,
      initMarkers,
      setOverlayProps,
      updateLayers
    ]
  );

  return (
    <MarkersContext.Provider value={value}>{children}</MarkersContext.Provider>
  );
};
